module.exports = function() {
  return new Worker(__webpack_public_path__ + "a74021d951bb99f74fbe.worker.js");
};